<template>
  <span>{{ (page - 1) * size + 1 + index }}</span>
</template>
<script>
export default {
  props: ["page", "size", "index"],
};
</script>